import {updateUseAllCoupon} from '@web/slices/orderSheetCoupon/slice'
import makeSlice from '@web/slices/orderSheetCoupon/sliceMaker'

import {fetchUseAllCoupon} from '../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchUseAllCoupon.fulfilled, (state, {payload}) => {
                state.useAllCoupon = payload.useAllCoupon
            })
            .addCase(updateUseAllCoupon, (state, {payload}) => {
                state.useAllCoupon = payload
            })
    },
})

export default slice.reducer
